export const ENDPOINTS = {
  get_questions: "support/faqs/",
  issue_types: "support/issue-types/",
  request: "support/requests/",
  tables_range: "support/tables-range/",
};